import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const STORAGE_KEY = "utm_data";

export default function useUTMTracker() {
  const location = useLocation();
  const [utmData, setUtmData] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    // Extract UTM parameters from URL
    const utm_source = queryParams.get("utm_source");
    const utm_campaign = queryParams.get("utm_campaign");
    const utm_medium = queryParams.get("utm_medium");
    const utm_term = queryParams.get("utm_term");
    const utm_content = queryParams.get("utm_content");

    const hasUtm =
      utm_source || utm_campaign || utm_medium || utm_term || utm_content;

    // Get existing stored data (if any)
    const stored = localStorage.getItem(STORAGE_KEY);
    const storedData = stored ? JSON.parse(stored) : null;

    // If URL has new UTM params → save & replace existing
    if (hasUtm) {
      const newData = {
        utm_source,
        utm_campaign,
        utm_medium,
        utm_term,
        utm_content,
        referrer: document.referrer || "direct",
        firstVisit: storedData?.firstVisit || Date.now(),
        lastUpdated: Date.now(),
      };

      localStorage.setItem(STORAGE_KEY, JSON.stringify(newData));
      setUtmData(newData);
    } else if (storedData) {
      // If no UTM in URL but stored data exists → reuse that
      setUtmData(storedData);
    } else {
      // If no UTM and nothing stored → fallback to referrer info
      const fallback = {
        utm_source: null,
        utm_campaign: null,
        utm_medium: null,
        utm_term: null,
        utm_content: null,
        referrer: document.referrer || "direct",
        firstVisit: Date.now(),
        lastUpdated: Date.now(),
      };

      localStorage.setItem(STORAGE_KEY, JSON.stringify(fallback));
      setUtmData(fallback);
    }
  }, [location.search]);

  return utmData;
}
